import {defineStore} from 'pinia';
import axios from "axios";

export const useSharedStore = defineStore('shared', {
    state: () => ({
        version: localStorage.getItem('version'),
        buildTime: localStorage.getItem('buildTime'),
        isDataFetched: Boolean(localStorage.getItem('version') && localStorage.getItem('buildTime')),
        privacyStatementName: localStorage.getItem('privacyStatementName'),
        privacyStatementUrl: localStorage.getItem('privacyStatementUrl'),
        registrarUrl: localStorage.getItem('registrarUrl')
    }),
    actions: {
        async fetchSharedData() {
            try {

                const [responseAppBuildInfo, responsePrivateStatement, responseAppInfo] = await Promise.all([
                    axios.get("/api/app/build"),
                    axios.get("/api/app/privacyStatement"),
                    axios.get("/api/app/info")
                ]);

                this.version = responseAppBuildInfo.data.version
                this.buildTime = responseAppBuildInfo.data.buildTime
                this.isDataFetched = true
                // persist data in localStorage
                if (this.version) localStorage.setItem('version', this.version)
                if (this.buildTime)  localStorage.setItem('buildTime', this.buildTime)

                this.privacyStatementName = responsePrivateStatement.data.name
                this.privacyStatementUrl = responsePrivateStatement.data.url
                // persist data in localStorage
                if (this.privacyStatementName) localStorage.setItem('privacyStatementName', this.privacyStatementName)
                if (this.privacyStatementUrl) localStorage.setItem('privacyStatementUrl', this.privacyStatementUrl)

                this.registrarUrl = responseAppInfo.data.registrarUrl
                // persist data in localStorage
                if (this.registrarUrl) localStorage.setItem('registrarUrl', this.registrarUrl)

            } catch (err) {
                console.error(err)
            }
        }
    }
})